import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
@Injectable()
export class BookingDetailsWrapperResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private charterDAO: CharterDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }
  resolve(route: ActivatedRouteSnapshot) {
    const charterResolve = this.charterDAO.getDetailsById(
      route.params.charterId,
    );
    const sessionResolve = this.authService.checkSession();
    return combineLatest([sessionResolve, charterResolve]).pipe(
      map(([sessionResolve, charterResolve]) => ({
        sessionResolve,
        charterResolve,
      })),
      take(1),
    );
  }
}
